const AsyncSome = async (array, matcher) => {
    return (await Promise.all(array.map(matcher))).some(Boolean);
};
module.exports = {
    AsyncSome
}